import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { truncateLabel } from '../../../../../helpers/string-helpers/string-helpers';
import { useProcessAnalysisStore } from '../../../../../store/process-analysis-store/process-analysis-store';
import {
  useSelectedInitiativeCompletions,
  useSelectedInitiativeCompletionTrends,
} from '../../../../../store/process-analysis-store/process-analysis-store.hooks';
import { LineChart } from '../../../components/line-chart/line-chart';
import { MetricType } from '../../../process-analysis.type';
import { useChartData } from './line-chart.hooks';

export const InitiativeCompletionLineChart = forwardRef<HTMLDivElement>((_, ref) => {
  const { t } = useTranslation();
  const selectedInitiativeCompletions = useSelectedInitiativeCompletions();
  const selectedInitiativeCompletionTrends = useSelectedInitiativeCompletionTrends();
  const metric = useProcessAnalysisStore((state) => state.initiativeCompletionMetric);

  const chartData = useChartData();
  const [hoveredInitiative, setHoveredInitiative] = useState<string | null>(null);

  const formatValue = (value: number | null): string => {
    if (value === null || value === undefined) {
      return t('common.labels.not_available');
    }

    const unit = metric === MetricType.WorkUnits ? t('common.work_units') : t('common.estimation');

    return `${value} ${unit}`;
  };

  const yAxisLabel = t('process_analysis.main_section.units_completed', {
    units: metric === MetricType.WorkUnits ? t('common.work_units') : t('common.estimation'),
  });

  return (
    <LineChart
      ref={ref}
      chartData={chartData}
      selectedItems={selectedInitiativeCompletions}
      selectedTrends={selectedInitiativeCompletionTrends}
      hoveredItem={hoveredInitiative}
      setHoveredItem={setHoveredInitiative}
      yAxisConfig={{
        label: yAxisLabel,
      }}
      formatValue={formatValue}
      formatItemName={truncateLabel}
      labelMaxLength={25}
    />
  );
});
